import React, { useContext, useEffect, useState } from 'react';
import P from 'prop-types';
const { io } = require('socket.io-client');
let SOCKET = io();

const SocketioContext = React.createContext();

export function useSocketio() {
  return useContext(SocketioContext);
}

export function SocketioProvider({ children }) {
  const [resposta, setResposta] = useState({});

  const socketConnect = (qs) => {
    if (SOCKET.connected) return;
    //SOCKET = io('http://localhost:3001/', { query: qs, rejectUnauthorized: false });
    //SOCKET = io('https://geneseweb.com.br:3001/', { query: qs, rejectUnauthorized: false });
    SOCKET = io('https://live.garcomweb.com.br:21022/', { query: qs, rejectUnauthorized: false });
  };

  const socketIsConnected = () => {
    return SOCKET.connected;
  };

  const socketEmit = (qs) => SOCKET.emit('Requisicao', qs);

  useEffect(() => {
    SOCKET.on('Resposta', (data) => {
      if (data) setResposta(data);
    });
  });

  const value = {
    socketResponse: resposta || '',
    socketEmit,
    socketConnect,
    socketIsConnected,
  };

  return <SocketioContext.Provider value={value}>{children}</SocketioContext.Provider>;
}

SocketioProvider.propTypes = {
  children: P.node,
  //children: React.ReactNode,
};
